import LeftNav1 from "../components/LeftNav1";
import NavigationBarModal from "../components/NavigationBarModal";

const NavigationBar = () => {
  const navigationData = [
    {
      title: `Overview`,
      text: `The L7 Toolbar for Navigation allows easy access and navigation to
      apps and widgets. It can be accessed from either side or the bottom of
      the screen. Check out the video and discover how enjoyable L7 Toolbar
      can make your digital experience!`,
      videoURL: `https://www.youtube.com/embed/QvZ3Pe_G1RQ`,
      dots: `dots1.png`,
      height: `376px`
    },
    {
      title: `Productivity Tools`,
      text: `The Toolbar also gives you quick access to more of the helpful apps
      provided. Press "More" to access tools like Timer, Spotlight,
      Calculators and Screen Freeze. For details, watch the video.`,
      videoURL: `https://www.youtube.com/embed/KLueq_J62Ww`,
      dots: `dots2.png`,
      height: `356px`
    },
    {
      title: `Screenshots & Screen Record`,
      text: `The Screen Capture tools are also located in the Toolbar. Easily
      access them and make your L7 experience even more seamless. Watch the
      video to learn more.`,
      videoURL: `https://www.youtube.com/embed/4Yy6Kksx-FI`,
      dots: `dots3.png`,
      height: `376px`
    },
    {
      title: `OneScreen Class`,
      text: `OneScreen Class is a specialized EdTech tool designed for teachers
      to interact with their student and keep them engaged. You can find
      it in your Toolbar for navigation and watch the video to learn how
      it works.`,
      videoURL: `https://www.youtube.com/embed/buCn4sh2fos`,
      dots: `dots4.png`,
      height: `376px`
    },
  ];
  return (
    <div className="h-screen overflow-hidden">
      <div className="flex p-1 mx-auto overflow-hidden justify-center w-[1300px] h-[620px] text-center text-xs text-darkslategray font-open-sans">
        <div className="bg-gray-200 mr-1">
          <LeftNav1 />
        </div>
        <div className="w-[1073px] bg-white mr-5 bg-tl-screen bg-center bg-cover h-[605px]">
          <div className="relative top-0 left-0 max-w-full h-full bg-gray backdrop-brightness-20">
            <NavigationBarModal data={navigationData} />
            <img
              className="absolute top-[70px] left-[10px] w-[38.7px] h-[452.6px] object-cover"
              alt=""
              src="/mainnav@2x.png"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavigationBar;
